import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import OfferBar from "./components/OfferBar";
import TopBar from "./components/TopBar";
import Header from "./components/Header";
import LoginModal from "./components/LoginModal";
import { useState, useEffect } from "react";
import Home from "./pages/Home";
import Hotels from "./pages/Hotels";
import HotelDetail from "./pages/HotelDetail";
import RoomDetail from "./pages/RoomDetail";
import AboutUs from "./pages/AboutUs";
import Services from "./pages/Services";
import ContactUs from "./pages/ContactUs";
import Blogs from "./pages/Blogs";
import BlogDetail from "./pages/BlogDetail";
import Profile from "./pages/Profile";
import ProtectedRoute from "./components/ProtectedRoute";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import Footer from "./components/Footer";
import HotelSearch from "./pages/HotelSearch";
import Faqs from "./pages/Faqs";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import PaymentPage from "./pages/PaymentPage";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import VerifySubscription from "./pages/VerifySubscription";
import UnsubscribeSubscription from "./pages/UnsubscribeSubscription";
import NotFound from "./pages/NotFound";
import CustomCursor from "./components/CustomCursor";
import ResetPassword from "./pages/ResetPassword";



// function App() {

//   useEffect(() => {
//     if ("scrollRestoration" in window.history) {
//       window.history.scrollRestoration = "manual";
//     }
//   }, []);

function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");

    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }

    setLoading(false);
  }, []);

  useEffect(() => {
    if (toast) {
      const timer = setTimeout(() => {
        setToast(null);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [toast]);

  if (loading) {
    return null;
  }

  return (
    <GoogleReCaptchaProvider reCaptchaKey="6LdZqVQtAAAAAHidZ_NNX0FZWdBJ1BKGkmYKPoXF">
      <BrowserRouter>
        <ScrollToTop />
        <OfferBar />
        <TopBar />
        <Header user={user} setUser={setUser} onLoginClick={() => setIsModalOpen(true)} setToast={setToast} />

        {/* ✅ ADD ROUTES ONLY FOR SEARCH + HOME */}
        <CustomCursor />
        <Routes>

          <Route path="/" element={<Home />} />
          <Route path="/hotels" element={<Hotels />} />
          <Route path="/hotels/:slug" element={<HotelDetail />} />
          <Route path="/hotels/:hotelSlug/:roomId" element={<RoomDetail />} />
          <Route path="/search-hotels" element={<HotelSearch />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blogs/:slug" element={<BlogDetail />} />
          <Route
            path="/profile"
            element={
              <ProtectedRoute user={user}>
                <Profile onLoginClick={() => setIsModalOpen(true)} />
              </ProtectedRoute>
            }
          />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />

          <Route path="/payment" element={<PaymentPage />} />
          <Route path="/payment-success" element={<PaymentSuccess onLoginClick={() => setIsModalOpen(true)} />} />
          <Route path="/payment-cancel" element={<PaymentCancel />} />

          <Route path="/verify-subscription/:token" element={<VerifySubscription />} />
          <Route path="/unsubscribe/:token" element={<UnsubscribeSubscription />} />
          <Route path="*" element={<NotFound />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />


        </Routes>

        <LoginModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} setUser={setUser} setToast={setToast} />

        {toast && (
          <div className="fixed top-5 right-5 z-50 bg-green-600 text-white px-5 py-3 rounded-xl shadow-lg">
            {toast.message}
          </div>
        )}

        <Footer setToast={setToast} />
      </BrowserRouter>
    </GoogleReCaptchaProvider >
  );
}

export default App;